module.exports = __webpack_public_path__ + "img/Depression.a3bd636.png";